// Local drafts in IndexedDB (until the server keeps drafts, and as an offline backup after).
import type { LoopData } from "@eb/shared";

export interface LocalDraft {
  id: string;
  day: number;
  loop: LoopData;
  title: string;
  updatedAt: number;
}

const DB = "endless-beat";
const STORE = "drafts";

function open(): Promise<IDBDatabase> {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB, 1);
    req.onupgradeneeded = () => {
      if (!req.result.objectStoreNames.contains(STORE)) req.result.createObjectStore(STORE, { keyPath: "id" });
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

async function tx<T>(mode: IDBTransactionMode, fn: (s: IDBObjectStore) => IDBRequest<T>): Promise<T> {
  const db = await open();
  try {
    return await new Promise<T>((resolve, reject) => {
      const t = db.transaction(STORE, mode);
      const req = fn(t.objectStore(STORE));
      req.onsuccess = () => resolve(req.result);
      req.onerror = () => reject(req.error);
    });
  } finally {
    db.close();
  }
}

export function loadDraft(id: string): Promise<LocalDraft | undefined> {
  return tx("readonly", (s) => s.get(id) as IDBRequest<LocalDraft | undefined>).catch(() => undefined);
}

export function saveDraft(d: LocalDraft): Promise<void> {
  return tx("readwrite", (s) => s.put(d)).then(() => undefined);
}

export function deleteDraft(id: string): Promise<void> {
  return tx("readwrite", (s) => s.delete(id)).then(() => undefined);
}
